import React from "react";

const FContainer = ({ children }) => {
  return (
    <div className="border-0 border-black w-full grid place-items-center pb-28">
      <div className="border-0  border-black w-full sm:w-[500px]">
        <div className="border-0  border-black w-full mb-16 grid place-items-center">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FContainer;
